/**
 * newsletter.js. Created by jeremydesvaux the 16 mai 2014
 */
(function ($, ns) {

  "use strict";

  /**
   * init module scripts, relative to its context (multiple context of the same module may exist in a page)
   * @param jQuery $context wraper div of the module
   */
  var newsletter = function (context) {
    this.$context = (context instanceof jQuery) ? context : $(context);
    this.init();
  };

  newsletter.prototype = {
    init: function () {
      this.registerFormSubmit();
    },
    registerFormSubmit: function () {
      var t = this;
      var $form = t.$context.find('form.nlForm');

      /**
       * Add no-ajax class to your newsletter form or form submit to disable ajax
      */
      if ($form.hasClass("no-ajax") || $form.find(":submit").hasClass("no-ajax")) {
          return false;
      }

      $form.on('submit', function (e) {
        e.preventDefault();

        //check form validity
        if ($form.valid && !$form.valid()) {
          return false;
        }
        if ($form.hasClass('loading')) {
          return false;
        }

        $form.addClass('loading').find('input[type="submit"]').prop("disabled", true);
        t.removeNotifications();

        t.submitForm($form);
      })
    },

    submitForm: function ($form) {
      var t = this;

      $.post($form.attr('action'), $form.serializeArray(), function (res) {

        if (res && res.code && res.code === 200) {
          t.onFormSuccess(res, $form);
        } else {
          t.onFormError(res, $form)
        }
      })
        .fail(function (jqXHR, textStatus, errorThrown) {
          t.onFormError({code: 500, textStatus: textStatus, errorThrown: errorThrown}, $form)
        })
        .always(function (jqXHR, textStatus) {
          $form.removeClass('loading').find('input[type="submit"]').prop('disabled', false);
        });
    },

    onFormSuccess: function (res, $form) {
      this.notify('success', res.data.msg, $form.parent());
      this.trackSubmitEvent($form, res);
      $form[0].reset();
    },

    onFormError: function (res, $form) {
      var notifType = res && res.code && res.code === 202 ? 'info' : 'error',
        notifMsg = res && res.data && res.data.msg ? res.data.msg : 'Error';
      this.notify(notifType, notifMsg, $form.parent());

      if (res && res.data && res.data.errors) {
        for (var i in res.data.errors) {
          var fieldName = i,
            fieldErrors = res.data.errors[i],
            $inputWrap = this.$context.find('.' + i + '-wrap');

          if ($inputWrap.length) {
            var errorLabel = '<label class="error">';
            for (var j in fieldErrors) {
              errorLabel += fieldErrors[j];
            }
            errorLabel += '</label>';

            var $existingLabel = $inputWrap.find('label.error');
            if ($existingLabel.length) {
              $existingLabel.replaceWith($(errorLabel));
            } else {
              $inputWrap.append($(errorLabel));
            }
          }
        }
      }
    },

    notify: function (type, msg, $dest) {
      var EventManager = window.EventManager || $(document);
      EventManager.trigger('notification', {
        type: type,
        msg: msg,
        dest: $dest,
        focus: true
      });
    },
    removeNotifications: function () {
      var $alert = this.$context.find('.alert');
      if ($alert.length) {
        $alert.remove();
      }
    },
    trackSubmitEvent: function ($form, res) {
      var $listInputs = $form.find('input[name="list[]"]')
      var EventManager = window.EventManager || $(document);

      $listInputs.each(function (i, listInput) {
        EventManager.trigger('Tracking.customEvent', {
          action: 'form_sent',
          category: 'newsletter',
          label: 'Inscription page : ' + window.location.pathname,
          value: listInput.value
        });
      });
    }
  };

  if (ns && ns.app) {
    ns.app.registerModule('newsletter', newsletter);
  } else {
    window.pew.addRegistryEntry({
      key: 'wdf-plugin-newsletter',
      domSelector: '.module-newsletter',
      classDef: newsletter
    });
  }

})(jQuery, window.wonderwp);
